


































































































































































































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import { mapState } from "vuex";
import { validationMixin } from "vuelidate";
import { required, minLength, requiredIf } from "vuelidate/lib/validators";

import { getFieldError } from "@/core/tools/forms/get_field_error";
import Attachments from "@/components/Controls/Attachments.vue";
import ColorComponent from "@/components/Controls/ColorComponent.vue";
import ProductTypeChildrenTab from "./ProductTypeChildrenTab.vue";
import {
  exportProductSpecDocx,
  exportProductSpecPdf,
  createProductSpecExportOptions
} from "../utils/productSpecExport";
import { resolveCatalogEntityId } from "../utils/openCatalogEntity";

import { STORE_KEY, store } from "./_store";

@Component({
  mixins: [validationMixin],
  computed: {
    ...mapState(STORE_KEY, [
      "loaded",
      "loading",
      "fatalError",
      "document",
      "form",
      "meta",
      "childrenLoaded",
      "savedBusinessScopes"
    ]),
    ...mapState("ubic", ["token"])
  },
  methods: {
    getFieldError
  },
  validations() {
    return {
      form: {
        name: { required, minLength: minLength(3) },
        code: {},
        record_type: { required },
        parent_id: {
          required: requiredIf(function(this: ProductTypeForm) {
            return this.form && this.form.record_type === "parent_product";
          })
        }
      }
    };
  },
  components: {
    Attachments,
    ColorComponent,
    ProductTypeChildrenTab
  }
})
export default class ProductTypeForm extends Vue {
  @Prop({ type: Boolean }) isNew!: boolean;
  @Prop({ type: Object }) documentPreview!: any;
  @Prop({ type: Object }) initParams!: any;

  document!: any;
  form!: any;
  meta!: any;
  loaded!: boolean;
  loading!: boolean;
  fatalError!: boolean;
  token!: string;
  childrenLoaded!: boolean;
  savedBusinessScopes!: any[];

  activeTab = 0;

  get isParentProduct() {
    return this.form && this.form.record_type === "parent_product";
  }

  get parentProductId() {
    const entityId = resolveCatalogEntityId(this, this.documentPreview);
    if (entityId != null) {
      return entityId;
    }
    if (this.document && this.document.id) {
      return this.document.id;
    }
    return null;
  }

  public created() {
    // @ts-ignore
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store);
    }
  }

  public mounted() {
    if (this.isNew) {
      this.$store.dispatch(`${STORE_KEY}/prepareNew`, this.initParams);
      return;
    }

    const entityId = resolveCatalogEntityId(this, this.documentPreview);
    if (entityId != null) {
      this.$store.dispatch(`${STORE_KEY}/init`, { id: entityId });
    }
  }

  onTabChange(tabIndex: number) {
    console.debug("[ProductTypeForm.tabs]", {
      activeTab: tabIndex,
      isParentProduct: this.isParentProduct
    });

    if (tabIndex === 1 && this.parentProductId && !this.childrenLoaded) {
      this.$store.dispatch(`${STORE_KEY}/loadChildren`, this.parentProductId);
    }
  }

  changeValue(field: string, value: any) {
    this.$store.dispatch(`${STORE_KEY}/changeFormValue`, {
      field,
      newValue: value
    });
    // @ts-ignore
    if (this.$v.form[field]) {
      // @ts-ignore
      this.$v.form[field].$touch();
    }
  }

  onProtectedRecipeChange(value: any) {
    console.debug("[ProductTypeForm] toggle protected_recipe", {
      value: !!value
    });
    this.changeValue("protected_recipe", !!value);
  }

  saveFormData(closeOnSuccess = true) {
    this.$v.form.$touch();

    if (!this.$v.form.$error) {
      this.$store
        .dispatch(
          `${STORE_KEY}/saveForm`,
          resolveCatalogEntityId(this, this.documentPreview)
        )
        .then(() => {
          console.debug("[FIX][ProductTypeForm.saveFormData]", {
            closeOnSuccess
          });
          this.$buefy.snackbar.open(`Данные успешно сохранены`);
          this.$v.form.$reset();
          if (closeOnSuccess) {
            this.$emit("form-close");
            (this.$parent as any).close();
          }
        })
        .catch(() => {
          this.$buefy.snackbar.open({
            type: "is-warning",
            message: `При сохранении возникли проблемы. Попробуйте позже.`
          });
        });
    }
  }

  addAttachments(file: any) {
    this.$store.dispatch(`${STORE_KEY}/addAttachments`, { newValue: file });
  }

  removeFile(idx: number) {
    if (!this.form.attachments) {
      return;
    }
    this.form.attachments.splice(idx, 1);
    this.saveFormData(false);
  }

  addLabelAttachments(file: any) {
    this.$store.dispatch(`${STORE_KEY}/addLabelAttachments`, {
      newValue: file
    });
    console.debug("[ProductTypeForm.label]", {
      action: "add",
      count:
        (this.form.label_attachments && this.form.label_attachments.length) || 0
    });
  }

  removeLabelFile(idx: number) {
    if (!this.form.label_attachments) {
      return;
    }
    this.form.label_attachments.splice(idx, 1);
    console.debug("[ProductTypeForm.label]", {
      action: "remove",
      count: this.form.label_attachments.length
    });
    this.saveFormData(false);
  }

  addSpecificationAttachments(file: any) {
    this.$store.dispatch(`${STORE_KEY}/addSpecificationAttachments`, {
      newValue: file
    });
  }

  removeSpecificationFile(idx: number) {
    if (!this.form.specification_attachments) {
      return;
    }
    this.form.specification_attachments.splice(idx, 1);
    this.saveFormData(false);
  }

  async exportSpecification(format: "docx" | "pdf") {
    const parentId = this.parentProductId;
    console.debug("[ProductTypeForm.specExport]", {
      format,
      parentId,
      name: this.form && this.form.name
    });

    const productData = {
      ...this.form,
      product_name: this.form.name,
      type_name: this.resolveTypeName()
    };

    const exportOptions = createProductSpecExportOptions(
      this as any,
      productData,
      this.form.name
    );

    try {
      if (format === "docx") {
        await exportProductSpecDocx(exportOptions);
      } else {
        await exportProductSpecPdf(exportOptions);
      }

      this.$buefy.snackbar.open({
        type: "is-success",
        message: `Спецификация успешно скачана`
      });
    } catch (error) {
      console.error("[ProductTypeForm.specExport] error", error);
      this.$buefy.snackbar.open({
        type: "is-danger",
        message: "Ошибка при генерации файла спецификации"
      });
    }
  }

  resolveTypeName() {
    if (
      this.form &&
      this.form.parent_id &&
      this.meta &&
      this.meta.products_types
    ) {
      const type = this.meta.products_types.find(
        (item: any) => item.id === this.form.parent_id
      );
      return type ? type.name : "";
    }
    return "";
  }

  beforeDestroy() {
    this.$store.dispatch(`${STORE_KEY}/reset`);
  }
}
